import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getEmployees = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/employees', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getEmployee = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/employees/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeEmployee = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/employees', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateEmployee = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/employees/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteEmployee = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/employees/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchEmployees = async (term, token, scopeId) => (
	fetch( getDomain()+`/employees?filter[name]=${term}&filter[company_id]=${scopeId}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)

export const attachEmployeeLocation = (employeeId, locationId) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post(`/employee_location/${employeeId}/${locationId}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const detachEmployeeLocation = (employeeId, locationId) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/employee_location/${employeeId}/${locationId}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)